import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

import { useAuthStore } from '@/pinia/auth'
import { useBrandedStore } from '@/pinia/branded'
import { useBasketStore } from '@/pinia/basket'
import { useStyleStore } from '@/pinia/style'
import { useCustomerStore } from '@/pinia/customer'
import { useTouchStore } from '@/pinia/touch'

const tabKey = 'tabOpen'

export function useTabHandler() {
  const router = useRouter()
  const authStore = useAuthStore()
  const brandedStore = useBrandedStore()
  const basketStore = useBasketStore()
  const styleStore = useStyleStore()
  const customerStore = useCustomerStore()
  const touchStore = useTouchStore()

  function removeSessionKey() {
    sessionStorage.removeItem(tabKey)
  }

  function hydrate() {
    authStore.$hydrate()
    basketStore.$hydrate()
    styleStore.$hydrate()
    customerStore.$hydrate()
    touchStore.$hydrate()
  }

  function handleDuplicateTabs() {
    /* 
      - Sesson storage tabKey is removed on refresh, tab closure or leaving page. 
      - Also doesn't exist in new sessions. 
      - If exists on page load must be duplicate tab.
    */
    if (sessionStorage.getItem(tabKey) && authStore.isPortal && authStore.usingBrandedModeToken) {
      sessionStorage.removeItem(tabKey)
      window.location.replace(brandedStore.launchURL)
    } else {
      sessionStorage.setItem(tabKey, 'true')
    }
  }

  function handleAuthChangesAcrossTabs(event) {
    if (event.key === 'portal_auth' || event.key === 'business_auth') {
      const authhNew = JSON.parse(event.newValue)
      const authhOld = JSON.parse(event.oldValue)
      if (!authhNew?.loggedIn && authhOld?.loggedIn) {
        const url = authStore.login_url
        hydrate()
        router.replace({ path: '/logout', query: { path: url, redirect: router.currentRoute.value.path } })
      } else if (authhNew?.loggedIn && !authhOld?.loggedIn) {
        hydrate()
      }
    }
  }

  onMounted(() => {
    handleDuplicateTabs()
    window.addEventListener('beforeunload', removeSessionKey)
    window.addEventListener('storage', handleAuthChangesAcrossTabs)
  })
  onUnmounted(() => {
    window.removeEventListener('beforeunload', removeSessionKey)
    window.removeEventListener('storage', handleAuthChangesAcrossTabs)
  })
}
